// extracted by mini-css-extract-plugin
export var card = "_lm-5";
export var cardSelected = "_lm-4";
export var image = "_lm-3";
export var modal = "_lm-0";
export var modalContent = "_lm-1";
export var table = "_lm-2";